import React, { createContext, useState } from 'react';

import { PresetButtonItem } from '@/components/PresetButtons';
import { presetButtons } from '@/components/Profile/ProfileMembership/ProfileMembership';
import { BillingFrequency } from '@/components/SubscriptionCard/SubscriptionCard.utils';
import { EditProfileProps } from '@/pages/EditProfile';
import { TAlertMessage, useAlertMessage } from '@/Utils/useAlertMessage';
import { useModalsState } from '@/Utils/useModalsState';

type ModalName = 'requestToSendSms';

export const EditProfileContext = createContext<
  EditProfileProps & {
    getModalState: (modalName: ModalName) => boolean;
    toggleModal: (modalName: ModalName) => void;
    selectedBillingFrequencyButton: PresetButtonItem;
    setSelectedBillingFrequencyButton: (button: PresetButtonItem) => void;
    selectedBillingFrequency: BillingFrequency;
    alertMessage: TAlertMessage | null;
    showAlert: (params: TAlertMessage) => void;
  }
>(null as any); // eslint-disable-line @typescript-eslint/no-explicit-any

export const EditProfileProvider: React.FC<EditProfileProps> = ({
  children,
  ...props
}) => {
  const [selectedBillingFrequencyButton, setSelectedBillingFrequencyButton] =
    useState<PresetButtonItem>(presetButtons[0]);
  const selectedBillingFrequency =
    selectedBillingFrequencyButton.value as BillingFrequency;

  const { getModalState, toggleModal } = useModalsState({
    requestToSendSms: false,
  });

  const { alertMessage, showAlert } = useAlertMessage();

  return (
    <EditProfileContext.Provider
      value={{
        ...props,
        getModalState,
        toggleModal,
        selectedBillingFrequencyButton,
        setSelectedBillingFrequencyButton,
        selectedBillingFrequency,
        alertMessage,
        showAlert,
      }}
    >
      {children}
    </EditProfileContext.Provider>
  );
};
